import React, { useState } from "react";
import { Offcanvas, Form } from "react-bootstrap";

function CourseFilter({ appliedFilters, show, onHide, onApplyFilter, onClear }) {
  const [filters, setFilters] = useState({
    search: appliedFilters?.search || "",
    language: appliedFilters?.language || "",
    status: appliedFilters?.status || "",
    published_status: appliedFilters?.published_status || "",
  });


  const handleFilterChange = (event) => {
    const { name, value } = event.target;
    setFilters({ ...filters, [name]: value });
  };

  const handleClearAll = () => {
    setFilters({
      search: "",
      language: "",
      status: "",
      published_status: "",
    });
    if (onClear) {
      onClear();
    }
  };

  const handleApply = () => {
    const cleanedFilters = {};
    Object.keys(filters).forEach(key => {
      if (filters[key] && filters[key].trim && filters[key].trim() !== "") {
        cleanedFilters[key] = filters[key].trim();
      } else if (filters[key] && filters[key] !== "") {
        cleanedFilters[key] = filters[key];
      }
    });
    
    if (onApplyFilter) {
      onApplyFilter(cleanedFilters);
    }
  };


  return (
    <Offcanvas
      className="mom_filter"
      show={show}
      onHide={onHide}
      placement="end"
      backdrop="static"
    >
      <Offcanvas.Header closeButton>
        <Offcanvas.Title className="font_blue_18 font-600">
          Filter Courses
        </Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body className="pt-0">
        <Form className="filter_form">
          <div className="mb-3">
            <label className="font_blue_14 font-500 mb-2">
              Search
            </label>
            <Form.Control
              type="text"
              placeholder="Search by Course Id, Title, Sub Title"
              name="search"
              value={filters.search}
              onChange={handleFilterChange}
              autoComplete="off"
            />
          </div>

            <div className="mb-3">
            <label className="font_blue_14 font-500 mb-2">
              Language
            </label>
            <Form.Control
              type="text"
              placeholder="Search by Language"
              name="language"
              value={filters.language}
              onChange={handleFilterChange}
              autoComplete="off"
            />
          </div>

          <div className="mb-3">
            <label className="font_blue_14 font-500 mb-2">Status</label>
            <Form.Select
              name="status"
              value={filters.status}
              onChange={handleFilterChange}
            >
              <option value="">All Status</option>
              <option value="Active">Active</option>
              <option value="Inactive">Inactive</option>
            </Form.Select>
          </div>

          <div className="mb-3">
            <label className="font_blue_14 font-500 mb-2">Published Status</label>
            <Form.Select
              name="published_status"
              value={filters.published_status}
              onChange={handleFilterChange}
            >
              <option value="">All</option>
              <option value="Published">Published</option>
              <option value="Draft">Draft</option>
            </Form.Select>
          </div>
        </Form>
        
        <div className="offcanvas-footer mt-4 d-flex gap-2">
          <button 
            className="btn blue_border flex-grow-1" 
            onClick={handleClearAll}
          >
            Clear All
          </button>
          <button
            className="btn red_button flex-grow-1"
            onClick={handleApply}
          >
            Apply
          </button>
        </div>
     
      </Offcanvas.Body>
    </Offcanvas>
  );
}

export default CourseFilter;